import { useTranslation } from 'react-i18next';
import { TRAIL_URL } from 'constants/config';

const colorSet = {
  red: { main: '#ea8676', bg: '#62707e', border: 'transparent' },
  green: { main: '#4ecdc4', bg: '#505b68', border: '#4ecdc4', shadow: '8px 6px 0px 0px #30a098' },
};

function PricingCard({ prefix = 'free', color = 'red' }) {
  const { t } = useTranslation();

  return (
    <div
      className="w-64 py-12 flex flex-col items-center border"
      style={{
        height: '480px',
        background: colorSet[color].bg,
        borderColor: colorSet[color].border,
      }}
    >
      {/* 免費/會員 */}
      <div
        className="w-full h-12 flex flex-center text-2xl"
        style={{ background: colorSet[color].main }}
      >
        {t(`Pricing.${prefix}.title`)}
      </div>

      {/* $$$ /月 */}
      <div className="w-full text-2xl text-center my-10">{t(`Pricing.${prefix}.fee`)}</div>

      <div
        className="w-full text-center px-4"
        dangerouslySetInnerHTML={{ __html: t(`Pricing.${prefix}.desc`) }}
      />

      <div
        className="w-full text-center my-6 px-4"
        dangerouslySetInnerHTML={{ __html: t(`Pricing.${prefix}.desc2`) }}
      />

      <div
        className="w-full text-center px-4"
        dangerouslySetInnerHTML={{ __html: t(`Pricing.${prefix}.desc3`) }}
      />

      {/* 立即查看/加入會員 */}
      <a
        href={TRAIL_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="w-36 h-11 flex flex-center font-bold text-center mt-auto whitespace-pre-line rounded leading-none"
        style={{
          background: colorSet[color].main,
          ...(color === 'green' && { boxShadow: colorSet[color].shadow }),
        }}
      >
        {t(`Pricing.${prefix}.select`)}
      </a>
    </div>
  );
}

export default PricingCard;
